import { render } from "./asignIcon.vue?vue&type=template&id=f4d14002&scoped=true"
import script from "./asignIcon.vue?vue&type=script&lang=js"
export * from "./asignIcon.vue?vue&type=script&lang=js"

import "./asignIcon.vue?vue&type=style&index=0&id=f4d14002&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4d14002"]])

export default __exports__